/* Built In Imports */
// import { useState } from 'react';

/* External Imports */
import {
    Box
} from '@chakra-ui/react';
// import { Formik, Form, Field } from 'formik';
// import * as Yup from 'yup';

/* Internal Imports */
/* Components */
import SectionUI from '@components/UI/Common/SectionUI';
import StyleConfig from '@components/UI/Common/StyleConfig';
import useMarketo from '@hooks/useMarketoForm';
// import InputUI from '@components/Elements/InputUI';

/**
 * Renders the Marketo form Section  component
 *
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region for the section
 * @param {string} lang - Language for the section
 * @param {boolean} isLeftMenu - Responsive left Navbar for the section
 * @returns {ReactElement} Marketo form Section  component
 */

let postUrl = 'https://app-ab10.marketo.com/index.php/leadCapture/save2';

const MarketoScriptForm = ({ baseUrl, munchkinId, formId }) => {
  if (!(baseUrl && munchkinId && formId)) return;

  useMarketo({ baseUrl: baseUrl, munchkinId: munchkinId, formId: formId });

  return (
    <Box display="grid" placeContent="center">
      <form id={`mktoForm_${formId}`} />
    </Box>
  );
};

const MarketoFormSection = ({
  section,
  region,
  lang,
  isLeftMenu,
  pType,
  pageName,
}) => {
  return (
    <Box as="div" display="block" placeContent="center">
      <StyleConfig key={section?.sectionId} style={section?.styleConfig}>
        <>
          {section?.sectionContent && section?.sectionContent?.length
            ? section?.sectionContent?.map((secCon, i) => {
              // consoleLog('StyleConfig', secCon);
              return (
                <SectionUI
                  key={i}
                  sectionContent={secCon}
                  section={section}
                  region={region}
                  language={lang}
                  isLeftMenu={isLeftMenu}
                  pType={pType}
                  pageName={pageName}
                />
              );
            })
            : null}
          <MarketoScriptForm
            baseUrl="//app-ab10.marketo.com"
            munchkinId="172-EEU-190"
            formId="1182"
          />
        </>
      </StyleConfig>
    </Box>
  );
};

// const MarketoForm = ({ sectionContent, region, lang, isLeftMenu }) => {
//   const [err, setErr] = useState('');

//   const MarketoFormSchema = Yup.object().shape({
//     firstName: Yup.string()
//       .min(2, 'Too Short!')
//       .max(15, 'Too Long!')
//       .required('Required'),
//     lastName: Yup.string()
//       .min(2, 'Too Short!')
//       .max(15, 'Too Long!')
//       .required('Required'),
//     email: Yup.string().email('Invalid email').required('Required'),
//     city: Yup.string().required('Required'),
//     postalCode: Yup.number().required('Required'),
//     country: Yup.string().required('Required'),
//   });

//   return (
//     <Box
//       w={{ base: '90%', sm: '80%', md: '460px' }}
//       maxWidth="460px"
//       minW={'300px'}
//       m="0 auto"
//     >
//       <Formik
//         initialValues={{
//           firstName: '',
//           lastName: '',
//           email: '',
//           city: '',
//           postalCode: '',
//           country: '',
//         }}
//         validationSchema={MarketoFormSchema}
//         onSubmit={async values => {
//           await new Promise(r => setTimeout(r, 500));
//           // alert(JSON.stringify(values, null, 2));
//           const response = await axios({
//             method: 'POST',
//             url: postUrl,
//             data: values,
//           });

//           if (response.status < 300) {
//             consoleLog('data recd ======>>>>>', response.data);
//           }
//         }}
//       >
//         {({ values, handleChange, errors, isSubmitting }) => (
//           <Form
//             style={{
//               display: 'grid',
//               rowGap: '25px',
//               padding: '15px 0',
//               boxSizing: 'border-box',
//             }}
//           >
//             <style global jsx>
//               {`
//                 select {
//                   border-bottom: 1px solid #a1a1a1 !important;
//                   font-size: 12px !important;
//                 }
//               `}
//             </style>
//             <Flex
//               width={'100%'}
//               justifyContent="space-between"
//               flexDir={{ md: 'row', sm: 'column', base: 'column' }}
//               flexWrap="wrap"
//               m="0 auto"
//             >
//               <Field name="firstName">
//                 {({ field, form }) => (
//                   <FormControl
//                     isInvalid={form.errors.firstName && form.touched.firstName}
//                     display="flex"
//                     flexDir="column"
//                     maxWidth={{ md: '215px', sm: '460px', base: '300px' }}
//                     m={{ md: '0 15px 0 0', sm: '0', base: '0' }}
//                   >
//                     <label
//                       //  w={{ md: '215px', sm: '460px', base: '300px' }}
//                       w="100%"
//                       // m={{ md: '0 15px 0 0', sm: '0', base: '0' }}
//                       htmlFor="firstName"
//                     >
//                       First Name
//                     </label>
//                     <InputUI
//                       // wd={{ md: '215px', sm: '460px', base: '300px' }}
//                       // m={{ md: '0 15px 0 0', sm: '0', base: '0' }}
//                       field={field}
//                       id="firstName"
//                       placeholder="First Name"
//                       onChange={handleChange}
//                     />
//                     <FormErrorMessage justifyContent="left">
//                       {form.errors.firstName}
//                     </FormErrorMessage>
//                   </FormControl>
//                 )}
//               </Field>
//               <Field
//                 name="lastName"
//                 // width={{ md: '215px', sm: '460px', base: '300px' }}
//                 // m={{ md: '0 30px 0 0', sm: '0', base: '0' }}
//               >
//                 {({ field, form }) => (
//                   <FormControl
//                     isInvalid={form.errors.lastName && form.touched.lastName}
//                     display="flex"
//                     flexDir="column"
//                     maxWidth={{ md: '215px', sm: '460px', base: '300px' }}
//                     m={{ md: '0 0 0 15px', sm: '0', base: '0' }}
//                   >
//                     <label htmlFor="lastName">Last Name</label>
//                     <InputUI
//                       // wd={{ md: '215px', sm: '460px', base: '300px' }}
//                       // m={{ md: '0 0 0 15px', sm: '0', base: '0' }}
//                       field={field}
//                       id="lastName"
//                       placeholder="Last Name"
//                       onChange={handleChange}
//                     />
//                     <FormErrorMessage justifyContent="left">
//                       {form.errors.lastName}
//                     </FormErrorMessage>
//                   </FormControl>
//                 )}
//               </Field>
//             </Flex>
//             <Field name="email">
//               {({ field, form }) => (
//                 <FormControl
//                   isInvalid={form.errors.email && form.touched.email}
//                   maxWidth={{ md: '460px', sm: '460px', base: '300px' }}
//                 >
//                   <label htmlFor="email">Email</label>
//                   <InputUI
//                     field={field}
//                     id="email"
//                     placeholder="Email"
//                     onChange={handleChange}
//                   />
//                   <FormErrorMessage justifyContent="left">
//                     {form.errors.email}
//                   </FormErrorMessage>
//                 </FormControl>
//               )}
//             </Field>
//             <Field>
//               {({ field, form }) => (
//                 <FormControl
//                   name="country"
//                   id="country"
//                   isInvalid={form.errors.country && form.touched.country}
//                   //   maxW={{ md: '215px', sm: '460px', base: '300px' }}
//                   m={{ md: '0 15px 0 0', sm: '0', base: '0' }}
//                 >
//                   <label>Country</label>
//                   <SelectUI
//                     // wd={{ md: '215px', sm: '460px', base: '300px' }}
//                     // m={{ md: '0 15px 0 0', sm: '0', base: '0' }}
//                     field={field}
//                     id="country"
//                     options={CountriesCodes}
//                     placeholder="Select Country"
//                     onChange={handleChange} // or {form.handleChange}
//                     value={values.value}
//                   />
//                   <FormErrorMessage justifyContent="left">
//                     {form.errors.country}
//                   </FormErrorMessage>
//                 </FormControl>
//               )}
//             </Field>
//             <Field name="city" m="0 10px">
//               {({ field, form }) => (
//                 <FormControl
//                   isInvalid={form.errors.city && form.touched.city}
//                   display="flex"
//                   flexDir="column"
//                   width="100%"
//                 >
//                   <label htmlFor="city">City</label>
//                   <InputUI
//                     field={field}
//                     id="city"
//                     placeholder="City"
//                     onChange={handleChange}
//                     // isRequired
//                   />
//                   <FormErrorMessage justifyContent="left">
//                     {form.errors.city}
//                   </FormErrorMessage>
//                 </FormControl>
//               )}
//             </Field>
//             <Field name="postalCode">
//               {({ field, form }) => (
//                 <FormControl
//                   isInvalid={form.errors.postalCode && form.touched.postalCode}
//                   //   maxW={{ md: '215px', sm: '460px', base: '300px' }}
//                   m={{ md: '0 15px 0 0', sm: '0', base: '0 15px 0 0' }}
//                 >
//                   <label htmlFor="postalCode">Pin/Zip Code</label>

//                   <InputUI
//                     maxLength="6"
//                     // wd={{ md: '215px', sm: '460px', base: '300px' }}
//                     // m={{ md: '0 0 0 15px', sm: '0', base: '0' }}
//                     field={field}
//                     id="postalCode"
//                     placeholder="Pin Code"
//                     onChange={handleChange}
//                     // isRequired
//                   />
//                   <FormErrorMessage justifyContent="left">
//                     {form.errors.postalCode}
//                   </FormErrorMessage>
//                 </FormControl>
//               )}
//             </Field>
//             {err ? (
//               <Box color="red" textAlign="center">
//                 {err}
//               </Box>
//             ) : null}
//             <Box display="grid" placeContent="center">
//               <Button type="submit" borderRadius={'20px'}>
//                 Submit
//               </Button>
//             </Box>
//           </Form>
//         )}
//       </Formik>
//     </Box>
//   );
// };

export default MarketoFormSection;
